(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quas-article"] && !Shopify.designMode) return;
  try {
    
  /* Marks the section in view in the "On this page" menu. */
  if (!customElements.get('quas-article-toc')) {
    customElements.define(
      'quas-article-toc',
      class extends HTMLElement {
        connectedCallback() {
          const links = [...document.querySelectorAll('.quas-article-toc__link')];
          const targets = [...new Set(links.map((link) => link.hash))]
            .map((hash) => document.getElementById(decodeURIComponent(hash.slice(1))))
            .filter(Boolean);
          if (!targets.length) return;

          const setCurrent = (id) => {
            for (const link of links) {
              if (link.hash === `#${id}`) link.setAttribute('aria-current', 'location');
              else link.removeAttribute('aria-current');
            }
          };

          // The current section is the last heading above the reading line,
          // a third of the way down the viewport.
          let frame = 0;
          const update = () => {
            frame = 0;
            const line = window.innerHeight * 0.33;
            let current = targets[0];
            for (const target of targets) {
              if (target.getBoundingClientRect().top <= line) current = target;
              else break;
            }
            if (current.id !== this.currentId) {
              this.currentId = current.id;
              setCurrent(current.id);
            }
          };
          this.onScroll = () => {
            if (!frame) frame = requestAnimationFrame(update);
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }
      }
    );
  }

  /* Native share sheet where the device has one, otherwise copy the link. */
  if (!customElements.get('quas-article-share')) {
    customElements.define(
      'quas-article-share',
      class extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          this.status = this.querySelector('[role="status"]');
          this.button?.addEventListener('click', () => this.share());
        }

        async share() {
          const { url, title, copied } = this.dataset;
          const coarse = window.matchMedia('(pointer: coarse)').matches;
          if (navigator.share && coarse) {
            try {
              await navigator.share({ url, title });
              return;
            } catch (error) {
              if (error?.name === 'AbortError') return;
            }
          }
          try {
            await navigator.clipboard.writeText(url);
            this.status.textContent = copied;
            clearTimeout(this.timer);
            this.timer = setTimeout(() => (this.status.textContent = ''), 2400);
          } catch (error) {
            window.prompt('Copy this link', url);
          }
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
